module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAASVJREFUOE/tk7FKQnEUxn/fNTOisiC4EjQ1F0FLuQb1BL1B0NBwaWhraG7J65REQ08RNEQvUFE0NgVicgkcSq30f8JA0bw42NpZzzk/OOf7PvHHUnt/7tDGG5Msex6jcUwHXzbKfRRRnU4zVdlTpTXXAfihXWJMCH4av8vEjIwa4twgWw600wPIhPZgn6yV9/Uee1XBkpkadxI5YLUUaLsP0BwhG+3qLQ6wUrBksc6tIPwHDPkDWip8cCMjH/tEP7QnD64d+MBYlxISPGOkEfOeODZjvV/GnNURBxiziEQXwEkUzdHwEly5JosSm3GAiARbNDlDVGPdCC+CU8FGHOAC4QteB+XLYEFwVAp00uNE8pbKOJYEqUEAJyrlQI/tmU6Yhk31N9IZoxGPFz0jAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/kc-1.png
// module id = PzBP
// module chunks = 96